import { render } from "./CertificateImporter.vue?vue&type=template&id=00f8df86"
import script from "./CertificateImporter.vue?vue&type=script&lang=js"
export * from "./CertificateImporter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__